var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudigration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 31H21C19.7019 30.9997 18.4294 30.6384 17.3248 29.9565C16.2202 29.2746 15.3269 28.2989 14.7449 27.1386C14.1628 25.9783 13.9149 24.679 14.0288 23.3858C14.1427 22.0927 14.6139 20.8567 15.3898 19.816C16.1658 18.7753 17.2158 17.9708 18.4226 17.4925C19.6294 17.0142 20.9454 16.8809 22.2237 17.1075C23.5019 17.3341 24.6919 17.9116 25.6607 18.7756C26.6296 19.6396 27.3391 20.756 27.71 22H29.5C30.6935 22 31.8381 22.4741 32.682 23.318C33.5259 24.1619 34 25.3065 34 26.5C34 27.6935 33.5259 28.8381 32.682 29.682C31.8381 30.5259 30.6935 31 29.5 31Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudigration);
export default __webpack_public_path__ + "static/media/Cloudigration.f8b25b7ffda77b6f490c11e0a9693fac.svg";
export { ForwardRef as ReactComponent };